export default __webpack_public_path__ + "static/media/espacoServidor.4fd97d39.png";